"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (e, t) {
  for (var n in t) {
    e[n] = t[n];
  }
}(exports, function (e) {
  var t = {};function n(i) {
    if (t[i]) return t[i].exports;var r = t[i] = { i: i, l: !1, exports: {} };return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }return n.m = e, n.c = t, n.d = function (e, t, i) {
    n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: i });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var i = Object.create(null);if (n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var r in e) {
      n.d(i, r, function (t) {
        return e[t];
      }.bind(null, r));
    }return i;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 231);
}({ 231: function _(e, t, n) {
    e.exports = n(232);
  }, 232: function _(e, t, n) {
    "use strict";
    n.r(t), n.d(t, "Sticky", function () {
      return i;
    });
    var i = function () {
      function i(e) {
        _classCallCheck(this, i);

        this.element = e, this.addEventHandlers(), this.makeElementSticky(), this.stickyHeight = this.element.offsetHeight;
      }

      _createClass(i, [{
        key: "addEventHandlers",
        value: function addEventHandlers() {
          var _this = this;

          window.addEventListener("resize", function () {
            _this.makeElementSticky();
          });
        }
      }, {
        key: "makeElementSticky",
        value: function makeElementSticky() {
          var _this2 = this;

          if ("none" !== getComputedStyle(this.element).getPropertyValue("display")) {
            var _e = this.element.offsetTop;window.scrollY > _e && (this.element.classList.add(this.classes.sticky), this.addExtraSpacingToNextElement()), window.addEventListener("scroll", function () {
              window.scrollY > _e ? (_this2.element.classList.add(_this2.classes.sticky), _this2.addExtraSpacingToNextElement()) : (_this2.element.classList.remove(_this2.classes.sticky), _this2.removeExtraSpacingNextElement());
            });
          }
        }
      }, {
        key: "addExtraSpacingToNextElement",
        value: function addExtraSpacingToNextElement() {
          this.next(this.element).setAttribute("style", "top: " + this.stickyHeight + "px; position: relative;");
        }
      }, {
        key: "removeExtraSpacingNextElement",
        value: function removeExtraSpacingNextElement() {
          this.next(this.element).removeAttribute("style");
        }
      }, {
        key: "next",
        value: function next(e) {
          do {
            e = e.nextSibling;
          } while (e && 1 !== e.nodeType);return e;
        }
      }, {
        key: "attributes",
        get: function get() {
          return {};
        }
      }, {
        key: "classes",
        get: function get() {
          return { sticky: this.element.dataset.rsSticky ? this.element.dataset.rsSticky : "is-sticky" };
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[data-rs-sticky]";
        }
      }]);

      return i;
    }();
  } }));